import React from "react";
import { useTranslation } from "react-i18next";
import { RISK_COLORS } from "../data/constants";

const RiskBadge = ({ risk, size = "sm" }) => {
  const { t } = useTranslation();
  const raw = risk?.toLowerCase()?.replace(/ /g, "_") || "pending";
  // Own keys only, so a stored value such as "constructor" is not read off
  // Object.prototype.
  const key = Object.prototype.hasOwnProperty.call(RISK_COLORS, raw) ? raw : "pending";
  const colors = RISK_COLORS[key];
  const label = t(`riskBadge.${key}`);

  const padding = size === "lg" ? "px-4 py-2 text-sm" : "px-2.5 py-1 text-xs";

  return (
    <span
      role="status"
      aria-label={t("riskBadge.ariaLabel", { label })}
      style={{
        backgroundColor: colors.bg,
        color: colors.text,
        border: `1px solid ${colors.border}`,
      }}
      className={`inline-flex items-center font-bold uppercase tracking-wider rounded-full ${padding}`}
    >
      <span
        className="w-1.5 h-1.5 rounded-full mr-1.5 inline-block"
        aria-hidden="true"
        style={{ backgroundColor: colors.text }}
      />
      {label}
    </span>
  );
};

export default RiskBadge;
